import { postAsync,getAsync } from "./http-client";

const CeoApi = {
  getHome: async (params) => {
    return await postAsync("/ceo/", params);
  },
  getDeleteStatus: async (ceoIdx) => {
    return await getAsync(`/ceo/getDeleteStatus/${ceoIdx}`);
  },
  getStatus: async (ceoIdx) => {
    return await getAsync(`/ceo/status/${ceoIdx}`);
  },
};
export default CeoApi;
